import React from 'react';
import Svg from '../Svg';

const IconFileJGP = ({ ...props }) => {
  return (
    <Svg {...props} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_440_4445)">
        <path
          d="M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z"
          fill="white"
          stroke="#D0D5DD"
          strokeWidth="1.5"
        />
        <path
          d="M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5"
          stroke="#D0D5DD"
          strokeWidth="1.5"
        />
        <rect x="1" y="18" width="26" height="16" rx="2" fill="#0BA5EC" />
        <path
          d="M7.65146 22.7273H9.17134V27.7983C9.17134 28.267 9.06599 28.6742 8.85529 29.0199C8.64696 29.3655 8.35695 29.6319 7.98526 29.8189C7.61358 30.0059 7.18152 30.0994 6.6891 30.0994C6.25112 30.0994 5.8534 30.0225 5.49592 29.8686C5.1408 29.7124 4.85908 29.4756 4.65075 29.1584C4.44241 28.8388 4.33943 28.4375 4.3418 27.9545H5.87234C5.87707 28.1463 5.91613 28.3108 5.98952 28.4482C6.06528 28.5831 6.16826 28.6873 6.29847 28.7607C6.43105 28.8317 6.5873 28.8672 6.76722 28.8672C6.95662 28.8672 7.11642 28.8269 7.24663 28.7464C7.3792 28.6636 7.47982 28.5429 7.54847 28.3842C7.61713 28.2256 7.65146 28.0303 7.65146 27.7983V22.7273ZM10.4426 30V22.7273H13.312C13.8636 22.7273 14.3335 22.8326 14.7218 23.0433C15.11 23.2517 15.406 23.5417 15.6096 23.9134C15.8155 24.2827 15.9185 24.7088 15.9185 25.1918C15.9185 25.6747 15.8143 26.1009 15.606 26.4702C15.3977 26.8395 15.0958 27.1271 14.7005 27.3331C14.3075 27.5391 13.8316 27.642 13.2729 27.642H11.4441V26.4098H13.0243C13.3203 26.4098 13.5641 26.3589 13.7559 26.2571C13.95 26.1529 14.0944 26.0097 14.1891 25.8274C14.2862 25.6428 14.3347 25.4309 14.3347 25.1918C14.3347 24.9503 14.2862 24.7396 14.1891 24.5597C14.0944 24.3774 13.95 24.2365 13.7559 24.1371C13.5617 24.0353 13.3155 23.9844 13.0172 23.9844H11.9803V30H10.4426ZM21.7397 25.0781C21.69 24.9053 21.6201 24.7526 21.5302 24.62C21.4402 24.4851 21.3301 24.3714 21.1999 24.2791C21.0721 24.1844 20.9253 24.1122 20.7596 24.0625C20.5962 24.0128 20.4151 23.9879 20.2163 23.9879C19.8446 23.9879 19.5179 24.0803 19.2362 24.2649C18.9568 24.4496 18.739 24.7183 18.5827 25.071C18.4265 25.4214 18.3484 25.8499 18.3484 26.3565C18.3484 26.8632 18.4253 27.294 18.5792 27.6491C18.7331 28.0043 18.9509 28.2753 19.2326 28.4624C19.5143 28.647 19.8469 28.7393 20.2305 28.7393C20.5785 28.7393 20.8756 28.6778 21.1218 28.5547C21.3704 28.4292 21.5598 28.2528 21.69 28.0256C21.8226 27.7983 21.8888 27.5296 21.8888 27.2195L22.2013 27.2656H20.3263V26.108H23.3697V27.0241C23.3697 27.6634 23.2347 28.2126 22.9648 28.6719C22.695 29.1288 22.3233 29.4815 21.8498 29.7301C21.3763 29.9763 20.8342 30.0994 20.2234 30.0994C19.5415 30.0994 18.9426 29.9491 18.4265 29.6484C17.9104 29.3454 17.5079 28.9157 17.2191 28.3594C16.9326 27.8007 16.7894 27.1378 16.7894 26.3707C16.7894 25.7812 16.8746 25.2557 17.0451 24.794C17.2179 24.33 17.4594 23.937 17.7695 23.6151C18.0797 23.2931 18.4407 23.0481 18.8526 22.88C19.2646 22.7119 19.7108 22.6278 20.1914 22.6278C20.6033 22.6278 20.9869 22.6882 21.342 22.8089C21.6971 22.9273 22.012 23.0954 22.2866 23.3132C22.5636 23.531 22.7897 23.7902 22.9648 24.0909C23.14 24.3892 23.2525 24.7183 23.3022 25.0781H21.7397Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_440_4445"
          x="-36"
          y="-12"
          width="112"
          height="112"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="12"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_440_4445"
          />
          <feOffset dy="24" />
          <feGaussianBlur stdDeviation="24" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0625882 0 0 0 0 0.0926346 0 0 0 0 0.15702 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_440_4445"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_440_4445"
            result="shape"
          />
        </filter>
      </defs>
    </Svg>
  );
};
export default IconFileJGP;
